module.exports = __webpack_public_path__ + "fonts/iconfont.9f014d6a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1571105669105
// module id = C3By
// module chunks = 240